(function () {
  var bar = document.querySelector('.accroloc-sticky-atc');
  if (!bar) return;

  var desktop = window.matchMedia('(min-width: 750px)');
  var target =
    document.querySelector('.product-form__submit') || document.querySelector('.cart__checkout-button');

  if (!target || desktop.matches) {
    bar.classList.remove('is-visible');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    },
    { threshold: 0.15 }
  );

  observer.observe(target);
})();
